import {useEntryPoint} from '@stripe-internal/conversations-assistant';

export function useDotComFeedbackButtons() {
  return useEntryPoint() === 'dot_com';
}

export function useDotComNoLlm() {
  return useEntryPoint() === 'dot_com';
}

export function useDotComCsf() {
  return useEntryPoint() === 'dot_com_embedded_csf';
}
